var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFacilityPeakStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4554 8.15862C17.96 7.67195 18.1308 6.95847 17.8968 6.31443C17.6771 5.66822 17.0863 5.1966 16.3744 5.09914L12.51 4.53824C12.4735 4.52826 12.4437 4.50328 12.4289 4.47025L10.7354 1.07083C10.432 0.420426 9.75013 0.000425352 8.99692 1.53537e-05C8.25265 -0.00288817 7.57574 0.406235 7.2674 1.04534L5.57391 4.44475C5.55522 4.47826 5.52258 4.5029 5.48383 4.51274L1.62844 5.09914C0.915877 5.1993 0.323702 5.66925 0.0970889 6.31443C-0.128194 6.96034 0.0453291 7.67085 0.547485 8.15862L3.39399 10.9206C3.41056 10.9558 3.41056 10.996 3.39399 11.0311L2.7274 14.8895C2.60092 15.5753 2.90456 16.2686 3.50734 16.6701C4.11012 17.0716 4.90416 17.1096 5.54688 16.7676L8.90684 15.0084C8.94072 14.9918 8.98106 14.9918 9.01494 15.0084L12.3749 16.7676C13.0182 17.1021 13.8075 17.0607 14.4076 16.661C15.0077 16.2613 15.3132 15.5734 15.1944 14.8895L14.5728 11.0481C14.5535 11.0166 14.5535 10.9777 14.5728 10.9461L17.4554 8.15862Z",
    fill: "#DCC91A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacilityPeakStar);
export default __webpack_public_path__ + "static/media/ic-facility-peakStar.e7dd5d4bb84bbfb9b94e284917f2b1d1.svg";
export { ForwardRef as ReactComponent };